import { create } from 'zustand';

const useLogoPlacementStore = create((set, get) => ({
  isPlaced: false,
  logoApplied: false,
  resetRequestId: 0,
  logoApplyRequestId: 0,
  logoUndoRequestId: 0,
  logoApplyStatus: 'idle',
  logoApplyInProgress: false,
  logoError: null,
  /** Bumped when the logo image source changes (default vs upload). */
  textureRevision: 0,
  customLogoTextureUrl: null,
  customLogoFileName: null,

  setPlaced: (isPlaced) => set({ isPlaced }),
  requestReset: () =>
    set((state) => ({
      isPlaced: false,
      resetRequestId: state.resetRequestId + 1,
      logoError: null,
    })),
  requestApplyLogo: () =>
    set((state) => ({
      logoApplyRequestId: state.logoApplyRequestId + 1,
      logoApplyStatus: 'applying',
      logoApplyInProgress: true,
      logoError: null,
    })),
  setLogoApplied: (logoApplied) =>
    set({
      logoApplied,
      logoApplyStatus: logoApplied ? 'applied' : 'idle',
      logoApplyInProgress: false,
      logoError: null,
    }),
  setLogoApplyError: (logoError) =>
    set({
      logoApplyStatus: 'idle',
      logoApplyInProgress: false,
      logoError,
    }),
  resetLogoApplyInProgress: () =>
    set({
      logoApplyStatus: 'idle',
      logoApplyInProgress: false,
    }),
  requestUndoLogo: () =>
    set((state) => ({
      logoUndoRequestId: state.logoUndoRequestId + 1,
      logoApplyStatus: 'undoing',
      logoError: null,
    })),
  setLogoUndone: () =>
    set({
      logoApplied: false,
      logoApplyStatus: 'idle',
      logoApplyInProgress: false,
      isPlaced: false,
      logoError: null,
    }),
  setCustomLogoTextureFile: (file) => {
    const prev = get().customLogoTextureUrl;
    if (prev) URL.revokeObjectURL(prev);
    if (!file) {
      set((state) => ({
        customLogoTextureUrl: null,
        customLogoFileName: null,
        textureRevision: state.textureRevision + 1,
        isPlaced: false,
        resetRequestId: state.resetRequestId + 1,
        logoError: null,
      }));
      return;
    }
    const url = URL.createObjectURL(file);
    set((state) => ({
      customLogoTextureUrl: url,
      customLogoFileName: file.name,
      textureRevision: state.textureRevision + 1,
      isPlaced: false,
      resetRequestId: state.resetRequestId + 1,
      logoError: null,
    }));
  },
  removeCustomLogoTexture: () => {
    get().useDefaultLogoTexture();
  },
  useDefaultLogoTexture: () => {
    const prev = get().customLogoTextureUrl;
    if (prev) URL.revokeObjectURL(prev);
    set((state) => ({
      customLogoTextureUrl: null,
      customLogoFileName: null,
      textureRevision: state.textureRevision + 1,
      isPlaced: false,
      resetRequestId: state.resetRequestId + 1,
      logoError: null,
    }));
  },
}));

export default useLogoPlacementStore;
